export const ALERT_FETCH_INTERVAL = 600000
